<template>
  <v-container class="mt-16 pt-4">
    <h1 class="monkey-title text-h3 mb-12 mt-6 text-accent">Mentions légales</h1>

    <v-card class="neu-sand px-5">
      <v-card-text>
        <h2 class="text-h4 mt-6 mb-3 text-accent">Informations légales</h2>

        <p><span class="font-weight-medium">Editeur du site :</span> INFOGRAPHART • EI Stanislas Castaybert</p>
        <p><span class="font-weight-medium">SIREN :</span> 882 885 635</p>
        <p><span class="font-weight-medium">Numéro de téléphone :</span> 07 78 56 07 25</p>
        <p><span class="font-weight-medium">Adresse e-mail :</span> hello@infographart.com</p>
        <p><span class="font-weight-medium">Hébergeur :</span> Vercel & Firebase par Google</p>
        <p><span class="font-weight-medium">Délégué à la protection des données (DPO) :</span> <NuxtLink to="mailto:stan@infographart.com" target="_blank">Stanislas Castaybert</NuxtLink></p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Contact</h2>

        <p>Pour toute question ou réclamation, vous pouvez contacter l'éditeur du site à l'adresse <NuxtLink to="mailto:hello@infographart.com" target="_blank">hello@infographart.com</NuxtLink>.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Hébergement</h2>

        <p>Le site Meili est hébergé par Vercel & Firebase, une société du groupe Google. Vous pouvez trouver plus d'informations sur Vercel & Firebase sur leur site web : <NuxtLink to="https://vercel.com" target="_blank">https://vercel.com</NuxtLink> et <NuxtLink to="https://firebase.google.com" target="_blank">https://firebase.google.com</NuxtLink>.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Propriété intellectuelle</h2>

        <p>Le site Meili et l'ensemble de son contenu, y compris les textes, images, vidéos et sons, sont protégés par le droit d'auteur et le droit de la propriété intellectuelle. Toute reproduction, représentation, modification, adaptation, distribution ou diffusion de tout ou partie du site Meili, sans l'autorisation préalable et écrite de l'éditeur, est interdite.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Liens hypertextes</h2>

        <p>Le site Meili peut contenir des liens hypertextes vers d'autres sites web. L'éditeur du site Meili n'exerce aucun contrôle sur ces sites web et n'assume aucune responsabilité quant à leur contenu.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Limitation de responsabilité</h2>

        <p>L'éditeur du site Meili ne peut être tenu responsable des dommages directs ou indirects, consécutifs ou non, résultant de l'utilisation du site Meili, de ses services ou de ses produits.</p>

        <h2 class="text-h4 mt-6 mb-3 text-accent">Loi applicable et juridiction compétente</h2>

        <p>Les présentes mentions légales sont régies par la loi française. En cas de litige, les tribunaux français seront seuls compétents.</p>
      </v-card-text>
    </v-card>

    <h5 class="mt-8"><span class="font-weight-medium">Dernière modification :</span> 05 juin 2024</h5>
  </v-container>
</template>

<script setup>
definePageMeta({
  title: "Politique de Confidentialité",
});
</script>

<script>
export default {
  name: "PrivacyPolicyPage",
};
</script>

<style scoped>
p {
  margin: 0.75rem 0;
}

h1 {
  text-align: center;
}
</style>
